import { SVGProps } from 'react';

const HatGlasses = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 18a2 2 0 0 0-4 0m4 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0m-4 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0m9-7-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11m-3 0h20"
    />
  </svg>
);
export default HatGlasses;
